<div class="p-1">
  Błąd wtyczki Szafir SDK Chrome Host, aby wykonać podpis upewnij się, czy
  czytnik kart jest poprawnie podłączony i zainstalowany oraz czy znajduje się w
  nim karta. Następnie spróbuj ponownie.
</div>
<div class="flex justify-end">
  <p-button
    styleClass="customInfoButton outlined"
    size="small"
    (click)="onCloseAndReload()"
    [label]="'Zamknij'"
  />
</div>
